import { unreachableCaseError } from "@edgetier/utilities";
import { TimePeriodGroupBy } from "@edgetier/watchtower-types";
import * as dateTimeFormats from "constants/anomalies";
import { format } from "date-fns";

/**
 * Format a date for displaying on chart. The label format will depend on what the user is viewing the data by (days
 * or hours).
 * @param groupBy  The grouping period (days or hours) that will define the label.
 * @param dateTime Date to format.
 * @returns        String label.
 */
export const formatDateTickValue = (dateTime: Date | number, groupBy: TimePeriodGroupBy | undefined) => {
    if (typeof groupBy !== "undefined") {
        switch (groupBy) {
            case TimePeriodGroupBy.Minutes: {
                return format(dateTime, dateTimeFormats.MINUTE_DATE_TIME_FORMAT);
            }
            case TimePeriodGroupBy.Hours: {
                return format(dateTime, dateTimeFormats.HOURLY_DATE_TIME_FORMAT);
            }
            case TimePeriodGroupBy.Days: {
                return format(dateTime, dateTimeFormats.DAILY_DATE_TIME_FORMAT);
            }
            case TimePeriodGroupBy.Weeks: {
                return format(dateTime, dateTimeFormats.WEEKLY_DATE_TIME_FORMAT);
            }
            case TimePeriodGroupBy.Months: {
                return format(dateTime, dateTimeFormats.MONTHLY_DATE_TIME_FORMAT);
            }
            default: {
                unreachableCaseError(groupBy);
                return dateTime.toString();
            }
        }
    }
    return dateTime.toString();
};
